import React, { useEffect, useState } from 'react';
import '../../css/AdminTable.css';
import { BACKEND_URL } from '../../config';
import CopyPhoneText from '../CopyPhoneText';

const VinRequestsAdmin = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [deletingId, setDeletingId] = useState(null);

    useEffect(() => {
        fetchRequests();
        // eslint-disable-next-line
    }, []);

    const fetchRequests = () => {
        setLoading(true);
        const token = localStorage.getItem('authToken');
        fetch(`${BACKEND_URL}/vin-requests`, {
            headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        })
            .then(res => {
                if (!res.ok) throw new Error('Не вдалося завантажити VIN-заявки');
                return res.json();
            })
            .then(setRequests)
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    };

    const handleDelete = async (id) => {
        setDeletingId(id);
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${BACKEND_URL}/vin-requests/${id}`, {
                method: 'DELETE',
                headers: token ? { 'Authorization': `Bearer ${token}` } : {}
            });
            if (!res.ok) throw new Error('Не вдалося видалити заявку');
            fetchRequests();
        } catch (err) {
            setError(err.message);
        } finally {
            setDeletingId(null);
        }
    };

    return (
        <div>
            <h2>VIN-заявки</h2>
            {loading && <div>Завантаження...</div>}
            {error && <div className="error-message">{error}</div>}
            {!loading && !error && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                    {requests.length === 0 ? (
                        <div style={{ textAlign: 'center' }}>Немає заявок</div>
                    ) : (
                        requests.map(req => (
                            <div key={req.id} style={{
                                background: '#fff',
                                borderRadius: 8,
                                boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
                                padding: 24,
                                border: '1px solid #eee',
                                maxWidth: 600,
                                position: 'relative'
                            }}>
                                <button
                                    onClick={() => handleDelete(req.id)}
                                    disabled={deletingId === req.id}
                                    style={{
                                        position: 'absolute',
                                        top: 16,
                                        right: 16,
                                        background: '#d9534f',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: 4,
                                        padding: '6px 12px',
                                        cursor: 'pointer',
                                        fontWeight: 500,
                                        fontSize: 14
                                    }}
                                    title="Видалити заявку"
                                >
                                    {deletingId === req.id ? '...' : 'Видалити'}
                                </button>

                                <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 6, paddingRight: 80 }}>
                                    <span style={{
                                        background: '#FFC93C',
                                        color: '#212529',
                                        borderRadius: 4,
                                        padding: '2px 8px',
                                        fontSize: 12,
                                        fontWeight: 700,
                                        marginRight: 8
                                    }}>
                                        VIN
                                    </span>
                                    {req.vin || <span style={{ color: '#888' }}>Не вказано</span>}
                                </div>

                                <div style={{ marginBottom: 6, color: '#555' }}>
                                    <span style={{ fontWeight: 500 }}>Деталь:</span>{' '}
                                    {req.partName || <span style={{ color: '#888' }}>Не вказано</span>}
                                </div>

                                <div style={{ marginBottom: 10, color: '#555' }}>
                                    <span style={{ fontWeight: 500 }}>Телефон:</span>{' '}
                                    <CopyPhoneText
                                        number={req.phone}
                                        style={{ color: '#2D6CDF', textDecoration: 'none' }}
                                    >
                                        {req.phone}
                                    </CopyPhoneText>
                                </div>

                                {req.createdAt && (
                                    <div style={{ fontSize: 12, color: '#aaa' }}>
                                        {new Date(req.createdAt).toLocaleString('uk-UA')}
                                    </div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default VinRequestsAdmin;
